import React from 'react'
import { circleDownArrow, viewIcon } from '../../../../assets'
import { CustomIcon } from '../../../../common/customAssets'
import { CustomText } from '../../../../common/custom'
import { PATHS } from '../../../../constants/paths'
import { useNavigate } from 'react-router-dom'

const LeaseProtectionActionMenu = ({ data, handleDownload, handleView, currentTab, handleDownloadCertificate }) => {
    const navigate = useNavigate()
    return (
        <div
            className={`w-[186px]  min-h-[50px] z-10 shadow-md bg-foundational-white  absolute top-[10px]
              right-[50px] rounded-[8px] flex flex-col items-center justify-center border-[1px] border-solid border-[#EAECF0] `}
        >
            {currentTab === "leads" && <div
                className={`cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] bg-hover rounded-[6px]`}
                onClick={() => handleView(data.attachment[0])}
            >
                <div className={`flex items-center`}>
                    {/* <Tooltip className='mt-[-10px] z-50' content='download'> */}
                    {' '}
                    <CustomIcon icon={viewIcon} />
                    {/* </Tooltip> */}
                    <CustomText className="font-inter font-[500] ml-[8px]">View Contract</CustomText>
                </div>
            </div>}
            {currentTab === "leads" && <div
                className={`cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] bg-hover rounded-[6px]`}
                onClick={() => handleDownload(data.attachment[0])}
            >
                <div className={`flex items-center`}>
                    {/* <Tooltip className='mt-[-10px] z-50' content='download'> */}
                    {' '}
                    <CustomIcon icon={circleDownArrow} />
                    {/* </Tooltip> */}
                    <CustomText className="font-inter font-[500] ml-[8px]">Download Contract</CustomText>
                </div>
            </div>}
            {currentTab === "coverages" && <div
                className={`cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] bg-hover rounded-[6px]`}
                onClick={() => navigate(PATHS.VIEWDETAILSLEASEPROTECTIONPOLICY, { state: { ...data } })}
            >
                <div className={`flex items-center`}>
                    <CustomIcon icon={viewIcon} />
                    <CustomText className="font-inter font-[500] ml-[8px]">View Details</CustomText>
                </div>
            </div>}
            {currentTab === "coverages" && <div
                className={`cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] bg-hover rounded-[6px]`}
                onClick={() => handleDownloadCertificate(data.id)}
            >
                <div className={`flex items-center`}>
                    <CustomIcon icon={circleDownArrow} />
                    <CustomText className="font-inter font-[500] ml-[8px]">Download Certificate</CustomText>
                </div>
            </div>}
        </div>
    )
}

export default LeaseProtectionActionMenu